<template>
    <vx-table class="xl:grid-cols-11-auto mb-8" rowBreakpoint="xl">
        <vx-table-row isHeader>
            <div class="lg:pl-6">Brand ID</div>
            <div>Source</div>
            <div>Name</div>
            <div>EIN</div>
            <div>Entity Type</div>
            <div>Verification</div>
            <div>Trust Score</div>
            <div>Campaigns</div>
            <div>Numbers</div>
            <div>Registered</div>
        </vx-table-row>

        <slot></slot>
    </vx-table>
</template>

<script lang="ts" setup>
import { VxTable, VxTableRow } from '@voxie/frontend-components';
</script>
